module.exports = __webpack_public_path__ + "officialStatic/img/solution3.ba57b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solution3.png
// module id = mStW
// module chunks = 0